// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__SxiYg","inputWrap":"CustomTip_inputWrap__1IThY"};